// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ne-1";
export var messageSideRight = "_ne-2";
export var orderLookupBubbleContainer = "_ne-0";
export var submitButton = "_ne-3";